import { observer } from 'mobx-react-lite'
import type { DependentsInfoRequestedSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/dependents-info/DependentsInfoRequestedSupportingItemViewModel'
import type { TaxInfoGatheringViewModel } from '@/features/jobs/details/tax-type/info-gathering/TaxInfoGatheringViewModel'
import { TaxInfoGatheringWizardContentButtonGroupContainer } from '@/features/jobs/details/tax-type/info-gathering/components/TaxInfoGatheringWizardContentButtonGroupContainer'
import { WizardContentBody, WizardContentFooter } from '@/components/Wizard'
import { DependentProfileCardListSectionContainer } from '@/features/jobs/details/tax-type/info-gathering/dependents-info/components/DependentProfileCardListSection/DependentProfileCardListSectionContainer'

export interface DependentsInfoWizardContentProps {
  itemVm: DependentsInfoRequestedSupportingItemViewModel
  taxInfoGatheringVm: TaxInfoGatheringViewModel
}

export const DependentsInfoWizardContentContainer = observer(
  function DependentsInfoWizardContentContainer({
    itemVm,
    taxInfoGatheringVm,
  }: DependentsInfoWizardContentProps) {
    const isSkeleton = itemVm.fetch.pending
    const isCompleteInfoGatheringPending =
      taxInfoGatheringVm.confirmCompleteInfoGathering.pending

    return (
      <>
        <WizardContentBody>
          <DependentProfileCardListSectionContainer
            vm={itemVm}
            isDisabled={isCompleteInfoGatheringPending}
          />
        </WizardContentBody>

        <WizardContentFooter>
          <TaxInfoGatheringWizardContentButtonGroupContainer
            isSkeleton={isSkeleton}
            variant="nav-only"
            taxInfoGatheringVm={taxInfoGatheringVm}
            itemVm={itemVm}
          />
        </WizardContentFooter>
      </>
    )
  },
)
